import { createContext, ReactNode, useContext, useState } from "react";

type ErrorMarkingScope = "cell" | "row" | null;

type ErrorMarkingContextType = {
  errorMarkingScope: ErrorMarkingScope;
  setErrorMarkingScope: (value: ErrorMarkingScope) => void;
  isErrorMarkingMode: boolean;
};

const ErrorMarkingContext = createContext<ErrorMarkingContextType | undefined>(
  undefined,
);

export const ErrorMarkingProvider = ({ children }: { children: ReactNode }) => {
  const [errorMarkingScope, setErrorMarkingScope] =
    useState<ErrorMarkingScope>(null);

  return (
    <ErrorMarkingContext.Provider
      value={{
        errorMarkingScope,
        setErrorMarkingScope,
        isErrorMarkingMode: errorMarkingScope !== null,
      }}
    >
      {children}
    </ErrorMarkingContext.Provider>
  );
};

// eslint-disable-next-line react-refresh/only-export-components
export const useErrorMarking = () => {
  const context = useContext(ErrorMarkingContext);
  if (!context)
    throw new Error("useErrorMarking must be used within ErrorMarkingProvider");
  return context;
};
